import React from 'react';

export default function LoginPannelloSinistro({ loginImage }) {
  if (loginImage) {
    return (
      <div className="hidden lg:block lg:w-1/2 relative overflow-hidden">
        <img src={loginImage} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-blue-900/30 flex flex-col justify-end p-12">
          <h2 className="text-white text-3xl font-bold leading-tight mb-3">Qualifia</h2>
          <p className="text-blue-100 text-sm">Gestione procedure PPP — D.lgs 36/2023</p>
        </div>
      </div>
    );
  }
  return (
    <div className="hidden lg:flex lg:w-1/2 bg-sidebar-gradient flex-col justify-between p-12 relative overflow-hidden">
      <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-white/5" />
      <div className="absolute -bottom-32 -left-16 w-96 h-96 rounded-full bg-white/5" />
      <div className="relative z-10">
        <span className="text-white font-bold text-xl tracking-wide">Qualifia</span>
      </div>
      <div className="relative z-10">
        <h2 className="text-4xl font-extrabold text-white leading-tight mb-4">
          Benvenuto<br />nel portale PPP
        </h2>
        <p className="text-white/60 text-base leading-relaxed max-w-sm">
          Gestisci le procedure di Partenariato Pubblico Privato in un'unica piattaforma.
        </p>
      </div>
      <p className="relative z-10 text-white/30 text-xs">Qualifia — D.lgs 36/2023</p>
    </div>
  );
}
